import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

export class UserTimezoneInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<unknown>, handler: HttpHandler) {
    req = req.clone({
      setHeaders: {
        'X-TimeZone': Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    });

    return handler.handle(req);
  }

}
